import { render } from "./ChallengeBottom.vue?vue&type=template&id=467cbada&scoped=true"
import script from "./ChallengeBottom.vue?vue&type=script&lang=js"
export * from "./ChallengeBottom.vue?vue&type=script&lang=js"

import "./ChallengeBottom.vue?vue&type=style&index=0&id=467cbada&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467cbada"]])

export default __exports__